import { string } from 'yup'

export const observationSchema = () => ({
  observation: string()
})
